import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_COMMS_STATS, GET_COMMS_STATS_ERROR, GET_COMMS_STATS_SUCCESS } from '../../actions.js';

function* getCommsStats({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/v1/comms-stats`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_COMMS_STATS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_COMMS_STATS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COMMS_STATS_ERROR, payload: error });
  }
}

export function* watchGetCommsStats() {
  yield takeEvery(GET_COMMS_STATS, getCommsStats);
}

function* getCommsStatsSaga() {
  yield all([fork(watchGetCommsStats)]);
}

export default getCommsStatsSaga;
